import { TooltipContext } from 'Components/Popups/Tooltip/Provider';
import { ReactNode, useContext, useEffect, useRef } from 'react';

export default function Tooltip({
  children,
  message,
}: {
  children: ReactNode;
  message: ReactNode;
}) {
  const { openWithContext, forceClose } = useContext(TooltipContext);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    return () => forceClose();
  }, []);
  return (
    <div
      ref={ref}
      onMouseEnter={(e) => {
        message &&
          openWithContext({
            data: message,
            anchor: ref.current!,
          });
      }}
      onMouseLeave={forceClose}
    >
      {children}
    </div>
  );
}
